// getShouldAutoplayPost.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';
import getOperationData from '../selector/getOperationData.js';

const MINIMUM_AUTOPLY_THRESHOLD = 0.5; // TODO: remote config
/**
 * Select should autoplay in post feed by post id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} postId - post id.
 * @return {Array} The selected should autoplay in post feed.
 */
const getShouldAutoplayPost = createCachedSelector(
  state => getOperationData(state, ['post'], 'intersecting'),
  (state, postId) => postId,
  (intersectingData = {}, postId) => {
    let result = false;
    try {
      let maxPostViewport = 0;
      const maxPostViewportList = Object.keys(intersectingData).reduce(
        (prev, curr) => {
          const post = intersectingData[curr];
          const { inViewportPercentage } = post;
          if (
            !inViewportPercentage ||
            inViewportPercentage < MINIMUM_AUTOPLY_THRESHOLD
          )
            return prev;

          if (inViewportPercentage === maxPostViewport) {
            prev.push(post);
          } else if (inViewportPercentage > maxPostViewport) {
            maxPostViewport = post.inViewportPercentage;
            prev = [post];
          }
          return prev;
        },
        []
      );
      if (maxPostViewportList.length) {
        const sortedList = maxPostViewportList.sort((a, b) => a.top - b.top);
        const length =
          maxPostViewportList.length % 2 === 0
            ? // start from index = 0, if only two full viewport element, play first one
              // if four, should play index = 1 (2nd element), etc.
              maxPostViewportList.length - 1
            : maxPostViewportList.length;
        const shouldAutoplayIndex = Math.floor(length / 2);
        result = sortedList[shouldAutoplayIndex].postId === postId;
      }
    } catch (error) {
      //
    }

    return result instanceof Collection ? result.toJS() : result;
  }
)((state, postId) => `getShouldAutoplayPost:${postId}`);

export default getShouldAutoplayPost;
